import { APP_BASE_HREF } from '@angular/common';
import { FactoryProvider, Injector, Provider, inject } from '@angular/core';

import { TOAST_MESSAGES_SERVICE } from '@hdms/shared/common-types';
import {
  CURRENCY_PROVIDER,
  OAUTH_LOGIN_SYNC_PROVIDER,
  PUNCHOUT_SESSION_COOKIE_NAME,
  SERVICE_WORKER_PROVIDER,
  TOKEN_STORE_PROVIDER
} from '@hdms/shared/data-access';
import { HOME_LINK_ENABLED, ToastMessagesService } from '@hdms/shared/ui-core';
import {
  CookieService,
  DATEPICKER_FORMAT_PROVIDERS,
  EnvironmentService,
  LOGGER_PROVIDER,
  LegacyLogoutService,
  LogoutService,
  PlatformService,
  StandaloneLogoutService,
  TAB_SYNC_CHANNEL
} from '@hdms/shared/util-core';

import { SSR_APP_ID } from './constants';
import { URL_SERIALIZER_PROVIDER } from './routing/custom-url.serializer';
import { PAGE_FRAME_PROVIDER } from './services/page-frame-loader.service';

// TODO: to be removed once Angular is decoupled from Hybris.
const LOGOUT_PROVIDER: FactoryProvider = {
  provide: LogoutService,
  useFactory: ({ isStandalone, hostContext }: EnvironmentService, injector: Injector) =>
    injector.get<LogoutService>(isStandalone || hostContext ? StandaloneLogoutService : LegacyLogoutService),
  deps: [EnvironmentService, Injector]
};

const HOME_LINK_PROVIDER: FactoryProvider = {
  provide: HOME_LINK_ENABLED,
  useFactory: () =>
    inject(PlatformService).isServer || inject(CookieService).get<boolean>(PUNCHOUT_SESSION_COOKIE_NAME) !== true
};

export const APP_PROVIDERS: Provider[] = [
  {
    provide: APP_BASE_HREF,
    useValue: '/'
  },
  {
    provide: TAB_SYNC_CHANNEL,
    useValue: SSR_APP_ID
  },
  {
    provide: TOAST_MESSAGES_SERVICE,
    useExisting: ToastMessagesService
  },
  CURRENCY_PROVIDER,
  SERVICE_WORKER_PROVIDER,
  TOKEN_STORE_PROVIDER,
  URL_SERIALIZER_PROVIDER,
  PAGE_FRAME_PROVIDER,
  DATEPICKER_FORMAT_PROVIDERS,
  LOGOUT_PROVIDER,
  LOGGER_PROVIDER,
  OAUTH_LOGIN_SYNC_PROVIDER,
  HOME_LINK_PROVIDER
];
